import { render, staticRenderFns } from "./Piggybank.vue?vue&type=template&id=75396ccf&scoped=true&"
import script from "./Piggybank.vue?vue&type=script&lang=js&"
export * from "./Piggybank.vue?vue&type=script&lang=js&"
import style0 from "./Piggybank.vue?vue&type=style&index=0&id=75396ccf&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75396ccf",
  null
  
)

export default component.exports